var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('img',{attrs:{"src":require("../assets/not_Found.png")}}),_c('h4',{staticClass:"title is-3"},[_vm._v("Page Not Found")]),_c('h4',{staticClass:"title is-5"},[_vm._v("Sorry, we couldn't find that page. ")])])
}]

export { render, staticRenderFns }